import { inject, Pipe, PipeTransform } from '@angular/core';
import { TeamModel } from 'models/generated/Identity.Api.Models.Team';
import { BrandService } from 'services/brand.service';
import { UserService } from 'services/user.service';

@Pipe({
	name: 'team'
})
export class TeamPipe implements PipeTransform {

	private readonly userService = inject(UserService);
	private readonly brandService = inject(BrandService);

	transform(team?: TeamModel | string, format?: string): string | undefined {

		if (typeof team === 'string') team = this.userService.team(team) ?? undefined;
		if (!team) return '';

		switch (format) {
			case 'brand':
				return this.brandService.getBrand(team.salesBrandId)?.name;
			case 'brandId':
				return team.salesBrandId;
			case 'brandShortName':
				return this.brandService.getBrand(team.salesBrandId)?.shortName;
			case 'name':
			default:
				return team.name;
		}
	}
}
